const config = {
  id: 30,
  name: '助播素材',
  type: 1,
  module_code: 'active_material', // bind的配置文件
  icon: 'icon-tms-red-packet',
  font_icon: '&#xe60f;',
  style_type: 1,
  link_type: 0,
  property_data: {}
};

export default config;


